<template>
  <div
    :class="[tupianItem.isCollect === true ? 'on':'no']"
    class="tupianCollectBtn PicTagCollect collect _pointer"
    @click="toggleTupianCollect(tupianItem)"
  >
    <i class="iconfont icon-collect"/>
  </div>
</template>

<script>
export default {
  name: "tupianCollectBtn",
  props: {
    // 单个图片信息
    tupianItem: {
      type: Object,
      default: () => {
      }
    }
  },

  methods: {
    toggleTupianCollect(tupianItem) {
      this.$emit('toggleTupianCollect', tupianItem);
    },
  }
}
</script>

<style lang="scss" scoped>
.tupianCollectBtn {
  @include Position(1, 2, 16px, -50px);
  width: 32px;
  height: 32px;
  background: #FFFFFF;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  @include LayoutFlex(1);
  transition: all 0.5s ease-in-out;
  z-index: 2;

  &.on {
    background-color: #F8CC44;

    .icon-collect {
      color: #FFFFFF;
    }

    &:hover {
      background: #DEB740;
    }


  }

  &.no {
    .icon-collect {
      color: #596080;
    }

    &:hover {
      .icon-collect {
        color: #F8CC44;
      }
    }
  }

}
</style>
